(function(){
  var grid = document.getElementById('shopGrid');
  if (!grid) return;

  var countEl = document.getElementById('shopCount');
  var sortSelect = document.getElementById('shopSort');
  var minInput = document.getElementById('priceMin');
  var maxInput = document.getElementById('priceMax');

  function getCards(){ return Array.prototype.slice.call(grid.querySelectorAll('.pcard')); }

  function applySort(){
    var val = sortSelect.value;
    var cards = getCards();
    if (val === 'price-asc') cards.sort(function(a,b){ return parseFloat(a.dataset.price) - parseFloat(b.dataset.price); });
    else if (val === 'price-desc') cards.sort(function(a,b){ return parseFloat(b.dataset.price) - parseFloat(a.dataset.price); });
    else if (val === 'name-asc') cards.sort(function(a,b){ return a.dataset.name.localeCompare(b.dataset.name); });
    else if (val === 'name-desc') cards.sort(function(a,b){ return b.dataset.name.localeCompare(a.dataset.name); });
    cards.forEach(function(c){ grid.appendChild(c); });
  }

  function applyPriceFilter(){
    var min = parseFloat(minInput.value);
    var max = parseFloat(maxInput.value);
    var visible = 0;
    getCards().forEach(function(c){
      var p = parseFloat(c.dataset.price);
      var show = true;
      if (!isNaN(min) && p < min) show = false;
      if (!isNaN(max) && p > max) show = false;
      c.style.display = show ? '' : 'none';
      if (show) visible++;
    });
    countEl.textContent = visible;
  }

  sortSelect.addEventListener('change', applySort);
  document.getElementById('priceApply').addEventListener('click', applyPriceFilter);
  document.getElementById('priceClear').addEventListener('click', function(){
    minInput.value = '';
    maxInput.value = '';
    applyPriceFilter();
  });

  grid.addEventListener('click', function(e){
    var btn = e.target.closest('.pcard-btn');
    if (!btn) return;
    var id = btn.getAttribute('data-product-id');
    var title = btn.getAttribute('data-product-title');
    var price = parseFloat(btn.getAttribute('data-product-price'));
    if (window.GWCart) {
      window.GWCart.add({ id: id, name: title, price: price, qty: 1 });
    }
    var original = btn.textContent;
    btn.textContent = 'Added ✓';
    btn.classList.add('added');
    setTimeout(function(){
      btn.textContent = original;
      btn.classList.remove('added');
    }, 1400);
  });
})();

